import React from 'react';
import { AutoSuggestField, SelectField } from '../form';
import { FieldValues, UseControllerProps } from 'react-hook-form';

type ManufacturingSizeInputFieldProps<T extends FieldValues = FieldValues> = {
  useAutoSuggest: boolean;
  controller: UseControllerProps<T>;
  label?: React.ReactNode;
  options: any;
  onBlur?: () => void;
  onFocus?: () => void;
  onClear?: () => void;
  newRegex?: RegExp;
  className?: string;
  autoCompleteProps?: Record<string, any>;
  selectProps?: Record<string, any>;
  showErrorTooltip?: boolean;
};

function ManufacturingSizeInputField<T extends FieldValues = FieldValues>({
  useAutoSuggest,
  controller,
  label,
  options,
  onBlur,
  onFocus,
  onClear,
  newRegex,
  className,
  autoCompleteProps = {},
  selectProps = {},
  showErrorTooltip,
}: ManufacturingSizeInputFieldProps<T>) {
  if (useAutoSuggest) {
    return (
      <AutoSuggestField<T>
        showErrorTooltip={showErrorTooltip}
        controller={controller}
        autoCompleteProps={{ ...autoCompleteProps, options }}
        label={label}
        newRegex={newRegex}
        className={className}
        onFocus={onFocus}
        onBlur={onBlur}
        onClear={onClear}
      />
    );
  }
  return (
    <SelectField<T>
      showErrorTooltip={showErrorTooltip}
      controller={controller}
      selectProps={{ ...selectProps, options }}
      label={label}
      className={className}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  );
}

export default ManufacturingSizeInputField;
